import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink, Icon } from '@plone/volto/components';
import cx from 'classnames';
import config from '@plone/volto/registry';

import blankSVG from '@plone/volto/icons/blank.svg';
import downloadSVG from '@redturtle/volto-rt-blocks/icons/download.svg';

/* Style */
import './downloads.less';

const DownloadsTemplate = ({ items, isEditMode, linkTitle, linkHref }) => {
  const ListingLinkMore =
    config.blocks.blocksConfig.listing?.link_more?.component;

  return items ? (
    <>
      <div className="downloads-wrapper">
        {items.map((item) => {
          return (
            <div className="content" key={item.id}>
              <Icon
                name={item['@type'] === 'File' ? downloadSVG : blankSVG}
                size="18px"
              />

              <div className="link-wrapper">
                <UniversalLink className="link" item={item} title={item?.title}>
                  {item?.title}
                </UniversalLink>
              </div>
            </div>
          );
        })}

      </div>
      {ListingLinkMore && <ListingLinkMore linkTitle={linkTitle} linkHref={linkHref} isEditMode={isEditMode} />}
    </>
  ) : (
    <></>
  );
};

DownloadsTemplate.propTypes = {
  items: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default DownloadsTemplate;
